<template>
  <AppLayout>
    <div class="col-12 layout-spacing">
      <div class="widget widget-six">
        <settingsMenu></settingsMenu>
        <div class="widget-heading">
          <div class="row">
            <div class="col-12 d-inline-flex align-items-center">
              <h4 class="me-3 my-0">Rodzaje dni wolnych</h4>
              <button @click="openModal" class="btn btn-primary btn-sm"><i class="bi bi-plus-circle me-2"></i>Dodaj nowy
                typ dni wolnych
              </button>
            </div>
          </div>
        </div>
        <div class="widget-content">
          <div class="custom-table">
            <div class="table-responsive">
              <table class="table table-hover">
                <thead>
                <tr>
                  <th>#</th>
                  <th>Nazwa</th>
                  <th>Opis</th>
                  <th>Opcje</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(wolne, index) in wolneTypyLocal" :key="index">
                  <td>{{ index + 1 }}</td>
                  <td>{{ wolne.nazwa }}</td>
                  <td>{{ wolne.opis }}</td>
                  <td>
                    <button @click="editWolne(wolne)" class="btn btn-sm btn-outline-info me-2 mb-2"><i
                        class="bi bi-pencil me-2"></i>Edytuj
                    </button>
                    <button @click="deleteWolne(wolne.id)" class="btn btn-sm btn-danger"><i
                        class="bi bi-trash me-2"></i>Usuń
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div v-if="isModalOpen" class="modal fade show" tabindex="-1" style="display: block;">
            <div class="modal-dialog modal-lg">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">Dodaj nowy dzień wolny</h5>
                  <button type="button" class="btn-close" @click="closeModal"></button>
                </div>
                <div class="modal-body">
                  <div class="row">
                    <div class="col-md-6">
                      <label class="form-label" for="nazwa">Nazwa typu dni wolnych:</label>
                      <input id="nazwa" v-model="newWolne.nazwa" class="form-control"/>
                    </div>
                    <div class="col-md-6">
                      <label class="form-label" for="nazwa_pdf">Nazwa na wydruku:</label>
                      <input id="nazwa_pdf" v-model="newWolne.nazwa_pdf" class="form-control"/>
                    </div>
                    <div class="col-md-6">
                      <label class="form-label" for="skrot">Skrót na karcie ewidencji czasu pracy:</label>
                      <input id="skrot" v-model="newWolne.skrot" class="form-control"/>
                    </div>
                    <div class="col-md-6">
                      <div class="checkbox-success custom-control custom-checkbox d-inline-block mt-3">
                        <input id="newWolne.kartka" type="checkbox" class="custom-control-input"
                               :checked="newWolne.kartka">
                        <label for="newWolne.kartka" class="custom-control-label form-label">Wymagane dostarczenie
                          kartki</label>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <label class="form-label" for="opis">Opis:</label>
                      <textarea id="opis" v-model="newWolne.opis" class="form-control" rows="3"></textarea>
                    </div>
                    <div class="col-md-6">
                      <div class="checkbox-success custom-control custom-checkbox d-inline-block mt-3">
                        <input id="newWolne.wypoczynkowy" type="checkbox" class="custom-control-input"
                               :checked="newWolne.wypoczynkowy">
                        <label for="newWolne.wypoczynkowy" class="custom-control-label form-label">Czy to
                          wypoczynkowy?</label>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="checkbox-success custom-control custom-checkbox d-inline-block mt-3">
                        <input id="newWolne.ojcowski" type="checkbox" class="custom-control-input"
                               :checked="newWolne.ojcowski" @change="changeOjcowski">
                        <label for="newWolne.ojcowski" class="custom-control-label form-label">Czy to ojcowski?</label>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="checkbox-success custom-control custom-checkbox d-inline-block mt-3">
                        <input id="newWolne.kadry_only" type="checkbox" class="custom-control-input"
                               :checked="newWolne.kadry_only">
                        <label for="newWolne.kadry_only" class="custom-control-label form-label">Dostępny tylko dla
                          kadr</label>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="checkbox-success custom-control custom-checkbox d-inline-block mt-3">
                        <input id="newWolne.rodzicielski" type="checkbox" class="custom-control-input"
                               :checked="newWolne.rodzicielski" @change="changeRodzicielski">
                        <label for="newWolne.rodzicielski" class="custom-control-label form-label">Czy to
                          rodzicielski?</label>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <label class="form-label" for="liczba">Czas trwania:</label>
                      <input id="liczba" type="number" v-model="newWolne.liczba" class="form-control"/>
                    </div>
                    <div class="col-md-6" v-if="newWolne.liczba">
                      <label class="form-label" for="dni_tygodni">Rodzaj czasu trwania:</label>
                      <select id="dni_tygodni" v-model="newWolne.dni_tygodni" class="form-select">
                        <option value="0">Dni</option>
                        <option value="1">Tygodni</option>
                        <option value="2">Miesięcy</option>
                      </select>
                    </div>
                    <div class="col-md-6" v-if="this.RodzicielskiChecked || this.OjcowskiChecked">
                      <label class="form-label" for="do_roku">Do którego roku od urodzenia:</label>
                      <input id="do_roku" type="number" v-model="newWolne.do_roku" class="form-control"/>
                    </div>
                    <div class="col-md-6">
                      <label class="form-label" for="opcje">Czy są dodatkowe opcje?:</label>
                      <select id="opcje" v-model="newWolne.opcje" class="form-select">
                        <option value="0">Nie</option>
                        <option value="1">Tak</option>
                      </select>
                    </div>
                    <div class="col-md-12">
                      <label class="form-label">Kolor na wydruku</label>
                      <div class="color-palette">
                        <div v-for="(kolor, index) in colorPalette" :key="'bg-'+index" class="color-box"
                             :class="{ selected: newWolne.kolor === kolor }" :style="{ backgroundColor: kolor }"
                             @click="selectNewColor(kolor)"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-danger" @click="closeModal">Anuluj</button>
                  <button class="btn btn-primary" @click="saveNewWolne">Zapisz</button>
                </div>
              </div>
            </div>
          </div>

          <div v-if="isEditModalOpen" class="modal fade show" tabindex="-1" style="display: block;">
            <div class="modal-dialog modal-lg">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">Edycja dnia wolnego</h5>
                  <button type="button" class="btn-close" @click="closeEditModal"></button>
                </div>
                <div class="modal-body">
                  <div class="row">
                    <div class="col-md-6">
                      <label class="form-label" for="nazwa">Nazwa typu dni wolnych:</label>
                      <input id="nazwa" v-model="editedWolne.nazwa" class="form-control"/>
                    </div>
                    <div class="col-md-6">
                      <label class="form-label" for="nazwa_pdf">Nazwa na wydruku:</label>
                      <input id="nazwa_pdf" v-model="editedWolne.nazwa_pdf" class="form-control"/>
                    </div>
                    <div class="col-md-6">
                      <label class="form-label" for="skrot">Skrót na karcie ewidencji czasu pracy:</label>
                      <input id="skrot" v-model="editedWolne.skrot" class="form-control"/>
                    </div>
                    <div class="col-md-6">
                      <div class="checkbox-success custom-control custom-checkbox d-inline-block mt-3">
                        <input id="editedWolne.kartka" type="checkbox" class="custom-control-input"
                               :checked="editedWolne.kartka" @change="changeEditKartka($event, editedWolne)">
                        <label for="editedWolne.kartka" class="custom-control-label form-label">Wymagane dostarczenie
                          kartki</label>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <label class="form-label" for="opis">Opis:</label>
                      <textarea id="opis" v-model="editedWolne.opis" class="form-control" rows="3"></textarea>
                    </div>
                    <div class="col-md-6">
                      <div class="checkbox-success custom-control custom-checkbox d-inline-block mt-3">
                        <input id="editedWolne.wypoczynkowy" type="checkbox" class="custom-control-input"
                               :checked="editedWolne.wypoczynkowy"
                               @change="changeEditWypoczynkowy($event, editedWolne)">
                        <label for="editedWolne.wypoczynkowy" class="custom-control-label form-label">Czy to
                          wypoczynkowy?</label>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="checkbox-success custom-control custom-checkbox d-inline-block mt-3">
                        <input id="editedWolne.ojcowski" type="checkbox" class="custom-control-input"
                               :checked="editedWolne.ojcowski" @change="changeEditOjcowski($event, editedWolne)">
                        <label for="editedWolne.ojcowski" class="custom-control-label form-label">Czy to
                          ojcowski?</label>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="checkbox-success custom-control custom-checkbox d-inline-block mt-3">
                        <input id="editedWolne.kadry_only" type="checkbox" class="custom-control-input"
                               :checked="editedWolne.kadry_only" @change="changeEditKadry($event, editedWolne)">
                        <label for="editedWolne.kadry_only" class="custom-control-label form-label">Dostępny tylko dla
                          kadr</label>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="checkbox-success custom-control custom-checkbox d-inline-block mt-3">
                        <input id="editedWolne.rodzicielski" type="checkbox" class="custom-control-input"
                               :checked="editedWolne.rodzicielski"
                               @change="changeEditRodzicielski($event, editedWolne)">
                        <label for="editedWolne.rodzicielski" class="custom-control-label form-label">Czy to
                          rodzicielski?</label>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <label class="form-label" for="liczba">Czas trwania:</label>
                      <input id="liczba" type="number" v-model="editedWolne.liczba" class="form-control"/>
                    </div>
                    <div class="col-md-6" v-if="editedWolne.liczba">
                      <label class="form-label" for="dni_tygodni">Rodzaj czasu trwania:</label>
                      <select id="dni_tygodni" v-model="editedWolne.dni_tygodni" class="form-select">
                        <option value="0">Dni</option>
                        <option value="1">Tygodni</option>
                        <option value="2">Miesięcy</option>
                      </select>
                    </div>
                    <div class="col-md-6" v-if="this.EditRodzicielskiChecked || this.EditOjcowskiChecked">
                      <label class="form-label" for="do_roku">Do którego roku od urodzenia:</label>
                      <input id="do_roku" type="number" v-model="editedWolne.do_roku" class="form-control"/>
                    </div>
                    <div class="col-md-6">
                      <label class="form-label" for="opcje">Czy są dodatkowe opcje?:</label>
                      <select id="opcje" v-model="editedWolne.opcje" class="form-select">
                        <option value="0">Nie</option>
                        <option value="1">Tak</option>
                      </select>
                    </div>
                    <div class="col-md-12">
                      <label class="form-label">Kolor na wydruku</label>
                      <div class="color-palette">
                        <div v-for="(kolor, index) in colorPalette" :key="'bg-'+index" class="color-box"
                             :class="{ selected: editedWolne.kolor === kolor }" :style="{ backgroundColor: kolor }"
                             @click="selectEditColor(kolor)"></div>
                      </div>
                    </div>
                    <div class="col-md-12" v-if="editedWolne.options && editedWolne.opcje == 1">
                      <label class="form-label mt-2">Lista opcji dnia wolnego:</label>
                      <div class="col-md-12">
                        <button @click="addNewOption(editedWolne.id)" class="btn btn-success btn-sm mb-2"><i
                            class="bi bi-plus-circle me-2"></i>Dodaj Opcje
                        </button>
                        <div v-if="addingNewOption" class="row">
                          <div class="col-md-12 col-lg-12 mb-3">
                            <label class="form-label" for="nazwa">Nazwa:</label>
                            <input id="nazwa" v-model="newOption.nazwa" type="text" class="form-control"
                                   style="border-radius: 0;"/>
                          </div>
                          <div class="col-md-12 col-lg-12 mb-3">
                            <label class="form-label" for="opis">Opis:</label>
                            <textarea id="opis" v-model="newOption.opis" class="form-control" style="border-radius: 0;"
                                      rows="3"></textarea>
                          </div>
                          <div class="col-md-12 col-lg-12 mb-3">
                            <label class="form-label" for="liczba">Liczba:</label>
                            <input id="liczba" v-model="newOption.liczba" type="number" class="form-control"
                                   style="border-radius: 0;"/>
                          </div>
                          <div class="col-md-12 col-lg-12 mb-3">
                            <label class="form-label" for="dni_tygodni">Jednostka:</label>
                            <select id="dni_tygodni" v-model="newOption.dni_tygodni" class="form-select">
                              <option value="0">Dni</option>
                              <option value="1">Tygodni</option>
                              <option value="2">Miesięcy</option>
                            </select>
                          </div>
                          <div class="modal-footer">
                            <button @click="saveNewOption" class="btn btn-sm btn-outline-success"><i
                                class="bi bi-save me-2"></i>Zapisz
                            </button>
                            <button @click="cancelNewOption" class="btn btn-sm btn-outline-primary"><i
                                class="bi bi-x-circle me-2"></i>Anuluj
                            </button>
                          </div>
                        </div>
                        <div v-if="editingOptionId === editedOption.id" class="row">
                          <div class="col-md-12 col-lg-12 mb-3">
                            <label class="form-label" for="nazwa">Nazwa:</label>
                            <input id="nazwa" v-model="editedOption.nazwa" type="text" class="form-control"
                                   style="border-radius: 0;"/>
                          </div>
                          <div class="col-md-12 col-lg-12 mb-3">
                            <label class="form-label" for="opis">Opis:</label>
                            <textarea id="opis" v-model="editedOption.opis" class="form-control"
                                      style="border-radius: 0;" rows="3"></textarea>
                          </div>
                          <div class="col-md-12 col-lg-12 mb-3">
                            <label class="form-label" for="liczba">Liczba:</label>
                            <input id="liczba" v-model="editedOption.liczba" type="number" class="form-control"
                                   style="border-radius: 0;"/>
                          </div>
                          <div class="col-md-12 col-lg-12 mb-3">
                            <label class="form-label" for="dni_tygodnie">Jednostka:</label>
                            <select id="dni_tygodnie" v-model="editedOption.dni_tygodni" class="form-select">
                              <option value="0">Dni</option>
                              <option value="1">Tygodni</option>
                              <option value="2">Miesięcy</option>
                            </select>
                          </div>
                          <div class="modal-footer">
                            <button @click="updateOption(editedOption)" class="btn btn-sm btn-outline-success"><i
                                class="bi bi-save me-2"></i>Zapisz
                            </button>
                            <button @click="cancelEditOption" class="btn btn-sm btn-outline-primary"><i
                                class="bi bi-x-circle me-2"></i>Anuluj
                            </button>
                          </div>
                        </div>

                        <div class="custom-table ">
                          <div class="table-responsive">
                            <table class="table table-hover">
                              <thead>
                              <tr>
                                <th>#</th>
                                <th>Nazwa</th>
                                <th>Opis</th>
                                <th>Liczba</th>
                                <th>Akcje</th>
                              </tr>
                              </thead>
                              <tbody>
                              <tr v-for="option in editedWolne.options" :key="option.id">
                                <td>{{ option.opcja }}</td>
                                <td>{{ option.nazwa }}</td>
                                <td>{{ option.opis }}</td>
                                <td>{{ option.liczba }} {{ SelectNaTekst(option.dni_tygodni) }}</td>
                                <td class="text-center">
                                  <button v-if="editingOptionId === option.id" @click="updateOption(option)"
                                          class="btn btn-sm btn-success me-2 mb-2">Zapisz
                                  </button>
                                  <template v-else>
                                    <button @click="editOption(option)" class="btn btn-sm btn-outline-info me-2 mb-2"><i
                                        class="bi bi-pencil me-2"></i>Edytuj
                                    </button>
                                    <br>
                                    <button @click="deleteOption(option.id)" class="btn btn-sm btn-danger"><i
                                        class="bi bi-trash me-2"></i>Usuń
                                    </button>
                                  </template>
                                </td>
                              </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-danger" @click="closeEditModal">Anuluj</button>
                  <button class="btn btn-primary" @click="updateWolne(editedWolne)">Zapisz</button>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";
import {usePermission} from "@/composables/resources/js/composables/permissions.js";
import settingsMenu from "@/Pages/Kadry/parts/settingsMenu.vue";

const {hasPermission} = usePermission();

export default {
  components: {AppLayout, settingsMenu},
  props: {
    urlopyTypy: Array
  },
  data() {
    return {
      colorPalette: ['#000000', '#2c3e50', '#1200ff', '#3498db', '#33FF57', '#3ddbd9', '#42c0e9', '#9dadb4', '#e84833', '#fd2602', '#FF5733', '#6e44ff', '#ffc107', '#17a60c', '#0000FF'],
      hasPermission,
      newWolne: {
        kolor: '#000000' // domyślny czarny dla nowych typów
      },
      editingId: null,
      addingNewOption: false,
      editingOptionId: null,
      addingNew: false,
      newWolne: this.getEmptyForm(),
      editedWolne: {},
      isModalOpen: false,
      isEditModalOpen: false,
      OjcowskiChecked: false,
      RodzicielskiChecked: false,
      EditOjcowskiChecked: false,
      EditRodzicielskiChecked: false,
      editedOption: {},
      wolneTypyLocal: [...this.urlopyTypy],
    };
  },
  watch: {
    urlopyTypy: {
      handler(nowe) {
        this.wolneTypyLocal = [...nowe]; // aktualizacja jeśli props się zmieni
      },
      immediate: true
    }
  },

  methods: {
    async openModal() {
      this.isModalOpen = true;
    },
    changeOjcowski() {
      this.newWolne.ojcowski = event.target.checked;
      console.log('ojcowski', this.newWolne.ojcowski);
      this.OjcowskiChecked = this.newWolne.ojcowski;
    },
    changeRodzicielski() {
      this.newWolne.rodzicielski = event.target.checked;
      console.log('ojcowski', this.newWolne.rodzicielski);
      this.RodzicielskiChecked = this.newWolne.rodzicielski;
    },

    changeEditOjcowski(event, editedWolne) {
      this.editedWolne = editedWolne;
      //this.editedWolne.ojcowski = event.target.checked;
      this.$set(this.editedWolne, 'ojcowski', event.target.checked);

      this.EditOjcowskiChecked = this.editedWolne.ojcowski;
      console.log('ojcowski', this.editedWolne.ojcowski);
    },
    changeEditRodzicielski(event, editedWolne) {
      //this.editedWolne.rodzicielski = event.target.checked;
      this.$set(this.editedWolne, 'rodzicielski', event.target.checked);
      this.editedWolne = editedWolne;
      this.EditRodzicielskiChecked = this.editedWolne.rodzicielski;
      console.log('ojcowski', this.editedWolne.rodzicielski);
    },
    changeEditWypoczynkowy(event, editedWolne) {
      //    this.editedWolne.wypoczynkowy = event.target.checked;
      this.editedWolne = editedWolne;
      this.$set(this.editedWolne, 'wypoczynkowy', event.target.checked);
      console.log('wypoczynkowy', this.editedWolne.wypoczynkowy);
    },
    changeEditKadry(event, editedWolne) {
      //   this.editedWolne.kadry_only = event.target.checked;
      this.editedWolne = editedWolne;
      this.$set(this.editedWolne, 'kadry_only', event.target.checked);
      console.log('kadry_only', this.editedWolne.kadry_only);
    },
    changeEditKartka(event, editedWolne) {
      //   this.editedWolne.kartka = event.target.checked;
      this.editedWolne = editedWolne;
      this.$set(this.editedWolne, 'kartka', event.target.checked);
      console.log('kartka', this.editedWolne.kartka);
    },
    closeModal() {
      this.isModalOpen = false;
      this.getEmptyForm();
      this.addingNewOption = false;
      this.editingOptionId = null;
    },

    closeEditModal() {
      this.isEditModalOpen = false;
      this.editingOptionId = null;

    },
    SelectNaTekst(select) {
      switch (select) {
        case 0:
          return 'Dni';
        case 1:
          return 'Tygodni';
        case 2:
          return 'Miesięcy';
        default:
          return '';
      }
    },

    getEmptyForm() {
      return {
        id: null,
        nazwa: '',
        nazwa_pdf: '',
        skrot: '',
        opis: '',
        wypoczynkowy: false,
        ojcowski: false,
        rodzicielski: false,
        kadry_only: false,
        kartka: false,
        liczba: null,
        dni_tygodni: '',
        do_roku: null,
        opcje: '0',
      };
    },
    getEmptyFormOption(wolne_id) {
      return {
        id: null,
        nazwa: '',
        opis: '',
        liczba: null,
        optionaddwolneid: wolne_id
      };

    },
    addWolne() {
      this.addingNew = true;
      this.newWolne = this.getEmptyForm();
    },
    cancelNewWolne() {
      this.addingNew = false;
      this.newWolne = this.getEmptyForm();
    },
    editWolne(wolne) {
      this.editingId = wolne.id;
      this.isEditModalOpen = true;
      this.editedWolne = wolne;

    },

    cancelEditOption() {
      this.editingOptionId = null;
    },

    editOption(option) {
      console.log('option', option);

      this.editingOptionId = option.id;
      this.editedOption = {...option};
    },
    addNewOption(wolne_id) {
      this.addingNewOption = true;
      this.newOption = this.getEmptyFormOption(wolne_id);
      console.log('wolne_id', wolne_id);
    },
    updateWolne(dane) {
      this.$inertia.put(route('kadry.wolne.update', dane.id), dane, {
        onSuccess: () => {
          const idx = this.wolneTypyLocal.findIndex(w => w.id === dane.id);
          if (idx !== -1) {
            this.$set(this.wolneTypyLocal, idx, {...dane});
          }
          this.editingId = null;
          this.isEditModalOpen = false;
        }
      });
    },

    saveNewWolne() {
      this.$inertia.post(route('kadry.wolne.dodaj'), this.newWolne, {
        onSuccess: (page) => {
          const nowy = page.props.flash?.nowyWolne ?? null;
          if (nowy) {
            this.wolneTypyLocal.push(nowy);
          }
          this.newWolne = this.getEmptyForm();
          this.isModalOpen = false;
          this.addingNew = false;
        }
      });
    },

    saveNewOption() {
      console.log('Dane:', this.newOption);
      this.$inertia.post(route('kadry.wolne.opcja.dodaj'), this.newOption, {
        onSuccess: (page) => {
          const nowy = page.props.flash?.nowyWolne ?? null;
          if (nowy) {
            // Dodajemy do lokalnej tablicy reaktywnie
            if (!this.editedWolne.options) this.editedWolne.options = [];
            this.editedWolne.options = [...this.editedWolne.options, nowy];
          }
          this.newWolne = this.getEmptyFormOption();
          this.isModalOpen = false;
          this.addingNewOption = false;
        },
        onError: () => {
          this.addingNewOption = false;
          console.log('Błędy:', this.newOption);
        }
      });
    },

    cancelNewOption() {
      this.addingNewOption = false;
      this.newOption = this.getEmptyFormOption();

    },


    updateOption(dane) {
      console.log('Dane:', dane);
      this.$inertia.put(route('kadry.wolne.opcja.update', dane.id), dane, {
        onSuccess: () => {
          const idx = this.editedWolne.options.findIndex(w => w.id === dane.id);
          if (idx !== -1) {
            // Tworzymy nową tablicę z zaktualizowaną opcją
            const updatedOptions = [...this.editedWolne.options];
            updatedOptions[idx] = {...dane};
            this.editedWolne.options = updatedOptions;
          }
          this.editingOptionId = null;
        }
      });
    },


    deleteWolne(id) {
      Toast.fire({
        toast: false,
        icon: 'warning',
        title: 'Usuwanie typu dni wolnych',
        html: 'Czy na pewno chcesz usunąć wybrany typ dni wolnych?',
        showDenyButton: true,
        showConfirmButton: true,
        confirmButtonText: 'Tak',
        denyButtonText: 'Nie',
        timer: false,
        position: 'center'
      }).then((result) => {
        if (result.isConfirmed) {
          this.$inertia.delete(route('kadry.wolne.usun', id));
          onSuccess: () => {
            this.wolneTypyLocal = this.wolneTypyLocal.filter(w => w.id !== id);
          }
        }
      });
    },

    deleteOption(id) {
      Toast.fire({
        toast: false,
        icon: 'warning',
        title: 'Usuwanie opcji dnia wolnego',
        html: 'Czy na pewno chcesz usunąć wybraną opcję dnia wolnego?',
        showDenyButton: true,
        showConfirmButton: true,
        confirmButtonText: 'Tak',
        denyButtonText: 'Nie',
        timer: false,
        position: 'center'
      }).then((result) => {
        if (result.isConfirmed) {
          this.$inertia.delete(route('kadry.wolne.opcja.usun', id), {
            onSuccess: () => {
              if (this.editedWolne && this.editedWolne.options) {
                // Zwracamy nową tablicę, aby Vue zareagowało
                this.editedWolne.options = this.editedWolne.options.filter(opt => opt.id !== id);
              }
            }
          });
        }
      });
    },

    selectEditColor(color) {
      this.editedWolne.kolor = color;
    },

    selectNewColor(color) {
      this.newWolne.kolor = color;
    }
  }
};
</script>

<style scoped>
.color-palette {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
}

.color-box {
  width: 30px;
  height: 30px;
  border: 2px solid #ccc;
  border-radius: 5px;
  cursor: pointer;
}

.color-box.selected {
  border: 3px solid #000;
}

</style>
